"use client"

import { ErrorSurface } from "@/features/website/pages/error-surface"
import { useSyncExternalStore } from "react"
import { LocaleProvider } from "@/i18n/client"
import { routeLocale, type Locale } from "@/i18n/routing"
import errorSpanish from "@/i18n/error.es.json"
import { WorkspaceError } from "@/features/workspace/workspace-error"
import { workspaceErrorSurface } from "@/features/workspace/error-context"

const subscribe = () => () => {}
const serverLocale = (): Locale => "en"

export default function GlobalError({ error, retry }: { error: Error & { digest?: string }; retry: () => void }) {
  const locale = useSyncExternalStore(subscribe, () => routeLocale(window.location.pathname), serverLocale)
  const surface = useSyncExternalStore(subscribe, () => workspaceErrorSurface(window.location.hostname, window.location.pathname), () => null)
  if (surface) return <html lang="en"><body style={{ margin: 0 }}><WorkspaceError error={error} retry={retry} surface={surface} /></body></html>
  return <html lang={locale}><body style={{ margin: 0 }}><LocaleProvider locale={locale} dictionary={locale === "es" ? errorSpanish : {}}><ErrorSurface retry={retry} /></LocaleProvider></body></html>
}
